import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/i18n/LanguageContext';

export type CrossSellTarget = 'service' | 'consult';

// Consulting has no English landing, so for EN users the card is hidden.
const URLS: Record<CrossSellTarget, { ru: string; en: string | null }> = {
  service: { ru: 'https://create-products.com/service', en: 'https://create-products.com/en/service' },
  consult: { ru: 'https://create-products.com/consult', en: null },
};

interface CrossSellCardProps {
  target: CrossSellTarget;
  /** Where in the app the card is shown — goes to utm_content. */
  placement: string;
  className?: string;
}

export function CrossSellCard({ target, placement, className = '' }: CrossSellCardProps) {
  const { t } = useTranslation('common');
  const { lang } = useLanguage();
  const base = lang === 'en' ? URLS[target].en : URLS[target].ru;
  if (!base) return null;

  const href = `${base}?utm_source=app&utm_medium=cta&utm_campaign=crosslink&utm_content=${encodeURIComponent(placement)}`;

  return (
    <div className={`bg-white rounded-[16px] p-[20px] md:p-[24px] flex flex-col md:flex-row md:items-center gap-[16px] ${className}`}>
      <div className="flex-1 min-w-0">
        <p className="font-manrope font-semibold text-[16px] md:text-[18px] leading-[24px] text-[#0d0d0d] mb-[4px]">
          {t(`crossSell.${target}.title`)}
        </p>
        <p className="font-segoe text-[14px] leading-[20px] text-[#565858]">
          {t(`crossSell.${target}.description`)}
        </p>
      </div>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="shrink-0 px-[24px] py-[12px] rounded-[16px] bg-[#2197f1] hover:bg-[#1a7bc7] text-white font-segoe font-semibold text-[16px] leading-[24px] text-center transition-colors"
      >
        {t(`crossSell.${target}.button`)}
      </a>
    </div>
  );
}
